import Clients from "../components/Clients";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Clients />
      <Contact />
    </div>
  );
}   

export default Home;